import React, { Component } from "react";
import PartnerFormPage from "./PartnerFormPage";
import {
  getServicePartner,
  getServicePartnerNames,
  updateServicePartner,
  uploadServicePartnerLogo,
} from "api/service partner/PartnerApi";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
import {
  EMPTY_PARTNER,
  openGoogleMaps,
  partnerFromApi,
  togglePartnerFeatureSubtype,
  togglePartnerFeatureType,
  updatePartnerField,
  validatePartner,
} from "./partnerFormUtils";
import "./partners.css";

class EditPartner extends Component {
  state = {
    partner: { ...EMPTY_PARTNER },
    errors: {},
    message: "",
    messageType: "info",
    partnerLoading: true,
    submitting: false,
    logoFile: null,
    partnerNames: [],
    partnerNamesLoading: true,
  };

  onLogoChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      this.setState((state) => ({
        errors: { ...state.errors, logo: "Logo must be 2 MB or smaller." },
      }));
      return;
    }
    this.setState((state) => ({
      logoFile: file,
      partner: { ...state.partner, logo: URL.createObjectURL(file) },
      errors: { ...state.errors, logo: null },
    }));
  };

  getId = () => this.props.match.params && this.props.match.params.id;

  componentDidMount() {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const partnerId = this.getId();

    getServicePartnerNames(obj)
      .then((res) =>
        this.setState({
          partnerNames: Array.isArray(res.data) ? res.data : [],
          partnerNamesLoading: false,
        }),
      )
      .catch(() => this.setState({ partnerNamesLoading: false }));

    if (!partnerId) {
      this.setState({
        partnerLoading: false,
        messageType: "danger",
        message: "Partner ID is missing.",
      });
      return;
    }

    getServicePartner(partnerId, obj)
      .then((res) => {
        const partner = res && res.data ? res.data : res;
        this.setState({
          partner: partnerFromApi(partner || {}),
          partnerLoading: false,
        });
      })
      .catch((error) =>
        this.setState({
          partnerLoading: false,
          messageType: "danger",
          message: getApiErrorMessage(error),
        }),
      );
  }

  onChange = (event) => {
    const { name, type, checked, value } = event.target;
    const fieldValue = type === "checkbox" ? checked : value;
    this.setState((state) => ({
      partner: updatePartnerField(state.partner, name, fieldValue),
      errors: { ...state.errors, [name]: null },
      message: "",
    }));
  };

  onFeatureTypeChange = (type, enabled) => {
    this.setState((state) => ({
      partner: togglePartnerFeatureType(state.partner, type, enabled),
      errors: { ...state.errors, partnerFeatures: null },
      message: "",
    }));
  };

  onFeatureSubtypeChange = (type, subtype, enabled) => {
    this.setState((state) => ({
      partner: togglePartnerFeatureSubtype(
        state.partner,
        type,
        subtype,
        enabled,
      ),
      errors: { ...state.errors, partnerFeatures: null },
      message: "",
    }));
  };

  onSubmit = (event) => {
    event.preventDefault();
    const errors = validatePartner(this.state.partner);
    if (Object.keys(errors).length) {
      this.setState({ errors });
      return;
    }

    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ submitting: true, message: "" });
    const logoUpload = this.state.logoFile
      ? uploadServicePartnerLogo(this.state.logoFile, obj)
      : Promise.resolve(null);

    logoUpload
      .then((upload) =>
        updateServicePartner(
          this.getId(),
          {
            ...this.state.partner,
            logo:
              upload && upload.data
                ? upload.data.logo
                : this.state.partner.logo,
          },
          obj,
        ),
      )
      .then((res) => {
        this.setState({
          submitting: false,
          messageType: "success",
          message: res.message || "Partner updated successfully.",
        });
        this.props.history.push("/admin/Service-partners-Branch");
      })
      .catch((error) =>
        this.setState({
          submitting: false,
          messageType: "danger",
          message: getApiErrorMessage(error),
        }),
      );
  };

  render() {
    return (
      <PartnerFormPage
        submitLabel="Save Changes"
        submittingLabel="Saving..."
        onSubmit={this.onSubmit}
        onBack={() => this.props.history.push("/admin/Service-partners-Branch")}
        message={this.state.message}
        messageType={this.state.messageType}
        submitting={this.state.submitting || this.state.partnerLoading}
        value={this.state.partner}
        inactiveLabel="Partner is inactive"
        errors={this.state.errors}
        onChange={this.onChange}
        onGetLocation={openGoogleMaps}
        onLogoChange={this.onLogoChange}
        onFeatureTypeChange={this.onFeatureTypeChange}
        onFeatureSubtypeChange={this.onFeatureSubtypeChange}
        partnerNames={this.state.partnerNames}
        partnerNamesLoading={this.state.partnerNamesLoading}
      />
    );
  }
}

export default EditPartner;
